<template>
  <div class="space-y-5">
    <div class="flex flex-row space-x-5">
      <div class="w-64">
        <my-select :options="types" v-model="type" :nullable="false" @change="handleChangeType"></my-select>
      </div>
      <div v-if="type.id === 1" class="flex-1 flex flex-row space-x-5">
        <my-select v-model="treatment" placeholder="Бүгд" :options="luTreatments" labelKey='treatmentAt' @change="handleChangeTreatment"></my-select>
      </div>
      <div v-else class="flex-1 flex flex-row space-x-5">
        <my-select v-model="year" placeholder="Бүх он" :options="years" @change="handleChangeYear"></my-select>
        <my-select v-model="month" placeholder="Бүх сар" :options="months" @change="handleChangeMonth"></my-select>
      </div>
    </div>
    <Count :list="totals" />
    <div class="flex flex-row space-x-5">
      <my-panel title="Эмчилгээнд орсон жилээр">
        <Bar :list="verifications" />
      </my-panel>
      <my-panel title="Эмчилгээний огноогоор">
        <Bar :list="treatments" />
      </my-panel>
    </div>
    <div class="flex flex-row space-x-5">
      <my-panel title="Үйлчлүүлэгчдийн хүйсээр">
        <Pie :list="genders" />
      </my-panel>
      <my-panel title="Аймгаар">
        <Bar :list="aimags" />
      </my-panel>
    </div>
  </div>
</template>

<script>
import Bar from '../components/chart/BarChart.vue'
import Pie from '../components/chart/PieChart.vue'
import Count from '../components/chart/CountChart.vue'
export default {
  name: 'BarChart',
  components: { Bar, Pie, Count },
  data () {
    return {
      totals: [{
        name: 'Нийт гэрээ',
        count: '0',
        icon: 'chart-bar',
        iconColor: 'bg-secondary'
      }, {
        name: 'Нийт орлого',
        count: '0',
        iconText: '₮',
        iconColor: 'bg-accent'
      }, {
        name: 'Цуцалсан гэрээ',
        count: '0',
        icon: 'exclamation',
        iconColor: 'bg-primary'
      }, {
        name: 'Хойшилсон',
        count: '0',
        icon: 'clock',
        iconColor: 'bg-orange-600'
      }],
      type: { id: 1 },
      types: [{
        id: 1,
        name: 'Эмчилгээний огноо'
      }, {
        id: 2,
        name: 'Он, сараар'
      }],
      verifications: [],
      treatments: [],
      treatment: null,
      year: null,
      month: null,
      aimags: [],
      genders: [],
      luTreatments: [],
      years: [],
      months: []
    }
  },
  created () {
    this.getLookups()
    this.handleRefresh()
  },
  methods: {
    handleChangeType () {
      this.year = null
      this.month = null
      this.treatment = null
      this.handleRefresh()
    },
    handleChangeTreatment () {
      this.handleRefresh()
    },
    handleChangeYear () {
      if (!this.year) {
        this.month = null
      }
      this.handleRefresh()
    },
    handleChangeMonth () {
      this.handleRefresh()
    },
    async getLookups () {
      try {
        const currentYear = new Date().getFullYear()
        for (let i = 2014; i <= currentYear; i++) {
          this.years.push({ id: i, name: i + ' он' })
        }
        for (let i = 1; i <= 12; i++) {
          this.months.push({ id: i, name: i + '-р сар' })
        }
        this.luTreatments = (await this.axios.get('lookups/treatments', { params: { selectStr: 'id, treatmentAt, note', orderStr: 'treatmentAt DESC' } })).data
      } catch (err) {
        this.handleError(err)
      }
    },
    async handleRefresh () {
      try {
        const query = {
          type: this.type.id,
          year: this.year ? this.year.id : null,
          month: this.month ? this.month.id : null,
          treatment: this.treatment ? this.treatment.id : null
        }
        const data = (await this.axios.get('dashboard', { params: query })).data
        this.verifications = data.verifications
        this.treatments = data.treatments
        this.aimags = data.aimags
        this.genders = data.genders
        this.totals = [{
          name: 'Нийт гэрээ',
          count: data.contractCount || 0,
          icon: 'chart-bar',
          iconColor: 'bg-secondary'
        }, {
          name: 'Нийт орлого',
          count: data.payment || 0,
          iconText: '₮',
          iconColor: 'bg-accent'
        }, {
          name: 'Цуцалсан гэрээ',
          count: data.contractCancel || 0,
          icon: 'exclamation',
          iconColor: 'bg-primary'
        }, {
          name: 'Хойшилсон',
          count: data.contractPostponed || 0,
          icon: 'clock',
          iconColor: 'bg-orange-600'
        }]
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>
